@if (objectiveGroup) {
    <adapt-objective-list-item [objective]="objectiveGroup!.objective"
                               [currentPageTeamId]="currentTeamId"
                               [depth]="depth"
                               [isExternalObjective]="isExternalObjective"
                               (objectiveChange)="onObjectiveChanged($event)"></adapt-objective-list-item>
    <ul>
        @for (childGroup of objectiveGroup.childGroups; track childGroup) {
            <li>
                <adapt-objective-list [objectiveGroup]="childGroup"
                                      [depth]="childDepth"
                                      [currentTeamId]="currentTeamId"
                                      (objectiveChange)="onObjectiveChanged($event)"></adapt-objective-list>
            </li>
        }
    </ul>
}
